/* eslint-disable prefer-const */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Button from '../UI/Buttons/buttons';
import css from './styles.module.scss';
import AccessUserRight from '../AccessUserRight';
import { ElementsNoneImages } from './Images';

type TOffersNoneProps = {
  /* От этого параметра меняетсятся текст */
  search?: boolean | null;
  status: string;
};

const OffersNone: FC<TOffersNoneProps> = ({ search, status }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const createOffers = () =>
    history.replace({
      pathname: `offer/create`,
    });

  return (
    <>
      <div className={css.empty}>
        <div className={css.img}>
          {search ? (
            <img
              src={ElementsNoneImages.no_search}
              alt={ElementsNoneImages.no_search}
            />
          ) : (
            <>
              {status === 'LAUNCHED' && (
                <img
                  src={ElementsNoneImages.offers_empty_active}
                  alt={ElementsNoneImages.offers_empty_active}
                />
              )}
              {status === 'ARCHIVE' && (
                <img
                  src={ElementsNoneImages.offers_empty_arhiv}
                  alt={ElementsNoneImages.offers_empty_arhiv}
                />
              )}
              {status === '' && (
                <img
                  src={ElementsNoneImages.offers_empty_all}
                  alt={ElementsNoneImages.offers_empty_all}
                />
              )}
            </>
          )}
        </div>
        {search ? (
          <div className={css.search}>
            <div className={css.header}>{`${t('search_none.none_1')}`}</div>
            <div className={css.text}>
              <span>{`${t('search_none.none_2')}`}</span>{' '}
              <span>{`${t('search_none.none_3')}`}</span>
            </div>
          </div>
        ) : (
          <div className={css.title}>
            {status === 'LAUNCHED' && t(`offers_page.active_offer_none`)}
            {status === 'ARCHIVE' && t(`offers_page.arhiv_offer_none`)}
            {status === '' && (
              <>
                <span
                  style={{
                    fontWeight: 400,
                  }}
                >
                  {t(`offers_page.empty_offers`)}
                </span>
                <div className={css.actions}>
                  <AccessUserRight>
                    {(props) => (
                      <Button
                        title={t(`offers_page.create_offer`)}
                        buttonAttributes={{
                          className: css.link,
                          onClick: createOffers,
                          disabled: props.isDisable,
                        }}
                      />
                    )}
                  </AccessUserRight>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};
export default OffersNone;
